import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Avatar, Icon } from '@material-ui/core'
import { find } from 'lodash'
import CreditAction from '../../../home/actions/CreditAction'
import AppStore from '../../../store/AppStore'
import HomeAction from '../../../home/actions/HomeAction'
import i18n from 'simple-react-i18n'
import ListItem from '@material-ui/core/ListItem'
import ListItemAvatar from '@material-ui/core/ListItemAvatar'
import ListItemText from '@material-ui/core/ListItemText'
import List from '@material-ui/core/List'
import DtoUserCredit from '../../../home/dto/DtoUserCredit'
import DtoUser from '../../../home/dto/DtoUser'
import DtoUserCreditHistory from '../../../home/dto/DtoUserCreditHistory'
import DtoCreditType from '../../../home/dto/DtoCreditType'
import DtoSelection from '../../../dashboard/dto/DtoSelection'
import { formatNumber } from '../../../utils/NumberUtils'
import { getDate } from '../../../utils/DateUtil'
import { orderBy } from 'lodash/collection'
import { connect } from 'react-redux'
import { css } from 'glamor'
import Tooltip from '@material-ui/core/Tooltip'

class CreditInformationPanel extends Component {
	constructor(props) {
		super(props)
		this.state = {
			creditNumber: 0
		}
	}

	componentWillMount() {
		if (!this.props.creditTypes.length) {
			AppStore.dispatch(CreditAction.fetchCreditTypes())
		}
		AppStore.dispatch(HomeAction.setTitle(i18n.credits))
	}

	getType = (creditHistory) => {
		if (this.props.creditTypes.length) {
			const creditType = find(this.props.creditTypes, (o) => {
				return o.id == creditHistory.creditTypeId
			})
			if (creditType) {
				return creditType
			}
			return ''
		}
		return ''
	}
	createIcon = (iconName, color) => {
		return (
			<Avatar>
				<Icon className='material-icons' { ...css({ color: color }) }>{ iconName }</Icon>
			</Avatar>
		)
	}
	createCreditIcon = (credit, creditTypes) => {
		const numberFormatted = formatNumber(credit)
		const finalText = (() => {
			switch (creditTypes.action) {
				case 'ADD':
					return [i18n.addCredit, '+' + numberFormatted]
				case 'SUBSTRACT':
					return [i18n.selectionExportCredit, '-' + numberFormatted]
				default:
					return ['', numberFormatted]
			}
		})()
		return (
			<Avatar { ...css({ fontSize: '10px !important' }) }>
				<Tooltip title={ finalText[0] } aria-label={ finalText[0] }>
					<span>{ finalText[1] }</span>
				</Tooltip>
			</Avatar>
		)
	}
	getIcon = (creditTypes) => {
		if (creditTypes) {
			switch (creditTypes.action) {
				case 'ADD':
					return this.createIcon('arrow_upward', 'green')
				case 'SUBSTRACT':
					return this.createIcon('arrow_downward', 'red')
				case 'REQUEST':
					return this.createIcon('info_outline', 'gray')
				default:
					return null
			}
		}
		return ''
	}
	getSelection = (selectionId) => {
		if (this.props.selections.length) {
			const selection = find(this.props.selections, (o) => {
				return o.id == selectionId
			})
			if (selection) {
				return selection.title
			}
			return ''
		}
		return ''
	}

	getCreditHistory() {
		if (this.props.userCreditHistory.length) {
			return orderBy(this.props.userCreditHistory, 'date', 'desc').map((creditHistory) => {
				const date = getDate(creditHistory.date)
				const creditTypes = this.getType(creditHistory)
				const creditTypeLibelle = (() => {
					if (creditTypes) {
						return creditTypes.libelle
					}
					return ''
				})()

				const selectionTitle = (() => {
					if (creditHistory.selectionId) {
						return this.getSelection(creditHistory.selectionId)
					}
					return ''
				})()

				const secondaryText = (() => {
					if (selectionTitle) {
						return date + ' - ' + selectionTitle
					}
					return date
				})()

				return (
					<ListItem alignItems='flex-start'>
						<ListItemAvatar>
							{ this.getIcon(creditTypes) }
						</ListItemAvatar>
						<ListItemText
							primary={ creditTypeLibelle }
							secondary={ secondaryText }
						/>
						<ListItemAvatar>
							{ this.createCreditIcon(creditHistory.credit, creditTypes) }
						</ListItemAvatar>
					</ListItem>
				)
			})
		}
		return null
	}

	getCreditInformation = () => {
		if (this.props.userCredit) {
			const title = (() => {
				if (this.props.userCredit.credit > 2) {
					return i18n.availableCredits
				}
				return i18n.availableCredit
			})()
			return (<span>{ title } : { this.props.userCredit.credit }</span>)
		}
		return null
	}

	change = (event) => {
		event.preventDefault()
		this.setState({
			creditNumber: Number(this.refs.creditNumber.value)
		})
	}

	creditRequest = () => {
		this.setState({
			creditNumber: 0
		})
		AppStore.dispatch(CreditAction.fetchCreditRequest(this.props.user.login, this.state.creditNumber))
	}

	getCreditRequestPanel = () => {
		return (
			<div className='row no-margin'>
				<div className='col s12 no-padding'>
					<fieldset>
						<legend>Demande de crédits</legend>
						<div className='row no-margin'>
							<div className='col s4 offset-s2'>
								<label htmlFor='creditNumber'/>
								<input ref={ 'creditNumber' } id='creditNumber' type='number' className='validate'
									   onChange={ (event) => this.change(event) } defaultValue={ this.state.creditNumber } style={ { height: '2rem !important' } }/>
							</div>
							<div className='col s2 offset-s1'>
								<a className='modal-action btn margin-right-10' onClick={ () => this.creditRequest() }>{ i18n.ask }</a>
							</div>
						</div>
					</fieldset>
				</div>
			</div>
		)
	}

	getContent = () => {
		if (this.props.userCreditHistory.length) {
			return (
				<div className='row no-margin'>
					<div className='col s12'>
						<div className='card-content'>
							<div className='row'>
								{ this.getCreditRequestPanel() }
							</div>
							<div className='row'>
								{ this.getCreditInformation() }
								<List>
									{ this.getCreditHistory() }
								</List>
							</div>
						</div>
					</div>
				</div>
			)
		}
		return (
			<div className='col s12'>
				<div className='row no-margin card'>
					<div className='col s12'>
						<div className='card-content'>
							<div className='row'>
								{ i18n.information.contactAddCredit }
							</div>
						</div>
					</div>
				</div>
				{ this.getCreditRequestPanel() }
			</div>

		)
	}

	render() {
		return (
			<div className='row'>
				<div className='col s6 offset-s3'>
					<div className='row card'>
						{ this.getContent() }
					</div>
				</div>
			</div>
		)
	}
}

CreditInformationPanel.propTypes = {
	user: PropTypes.instanceOf(DtoUser),
	userCredit: PropTypes.instanceOf(DtoUserCredit),
	userCreditHistory: PropTypes.arrayOf(PropTypes.instanceOf(DtoUserCreditHistory)),
	creditTypes: PropTypes.arrayOf(PropTypes.instanceOf(DtoCreditType)),
	selections: PropTypes.arrayOf(PropTypes.instanceOf(DtoSelection))
}

const mapStateToProps = store => {
	return {
		userCredit: store.CreditReducer.userCredit,
		userCreditHistory: store.CreditReducer.userCreditHistory,
		creditTypes: store.CreditReducer.creditTypes,
		selections: store.SelectionReducer.selections,
		user: store.HomeReducer.user
	}
}

export default connect(mapStateToProps)(CreditInformationPanel)



// WEBPACK FOOTER //
// ./src/administration/components/creditinformation/CreditInformationPanel.js